import React, { useContext, useEffect } from "react";
import { Grid } from "@mui/material";
import TitlePages from "../../components/generic/titlePages";
import CardSys from "../../components/cardSys";
import { api } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import TableLogs from "../../components/tableLogs";
import SelectLogsStart from "../../components/selectLogsStart";
import SelectLogsEnd from "../../components/selectLogsEnd";
import SelectLogs from "../../components/selectLogs";
import { useState } from "react";

export default function Logs() {
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [listLogs, setListLogs] = useState([]);
  const [endDate, setEndDate] = useState();
  const [selectStatus, setSelectStatus] = useState();
  const [body, setBody] = useState({});

  // useEffect(() => {
  //   if (user?.id) {
  //     if (user?.id_client !== 25886008) {
  //       navigate("/notpermission")
  //     }
  //   }
  // }, [user, navigate])

  useEffect(() => {
    // getLogs();
  }, []);

  async function getLogs() {
    handleLoading(true);
    try {
      let data = body;
      const { data: logs } = await api({ method: "POST", url: "/logs", data });
      setListLogs(logs);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  }
  
  return (
    <>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item xs={12}>
          <TitlePages>Logs</TitlePages>
        </Grid>
      </Grid>
      <CardSys>
        <Grid  marginTop="45px" marginLeft={"56px"} sx={{display:"flex",alignContent:"end",alignItems:"end"}} container 
        gap={3}
        >
          <Grid xs={1.4}  >
          <SelectLogsStart 
            onChange={(newStartDate) => {
              setBody((obj) => {
                obj.logStart = newStartDate ;
                return { ...obj };
              });
              getLogs();
            }}
            value={body.logStart || null}
            ></SelectLogsStart>
          </Grid>
          <Grid xs={1.4}  >
          <SelectLogsEnd 
            onChange={(newEndDate) => {
              setBody((obj) => {
                obj.logEnd = newEndDate;
                console.log(newEndDate);
                return { ...obj };
              });
              getLogs();
            }}
            value={body.logEnd || null }
            ></SelectLogsEnd>
            </Grid>
            <Grid xs={2.8}>
          <SelectLogs 
            onChange={({ target }) => {
              setBody((obj) => {
                obj.status = target.value;
                return { ...obj };
              });
              getLogs();
            }}
            value={body.status}
            ></SelectLogs>
            </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} marginTop="45px" marginBottom="45px" marginLeft={"56px"} marginRight={"56px"} justifyContent="center" alignItems="center">
            <TableLogs dados={listLogs}></TableLogs>
          </Grid>
        </Grid>
      </CardSys>
    </>
  );
}
